import { FC, ReactElement } from 'react'
import { Message } from './notification'

interface ModalProps {
  message: Message
  onClose: () => void
}

export const Modal: FC<ModalProps> = ({ message, onClose }): ReactElement => {
  const onOk = () => {
    if (message?.actions?.onOk) {
      message?.actions?.onOk()
    }

    onClose()
  }

  return (
    <>
      <div className="modals active">
        <div className="modals__wrapper">
          <div className="modals__head">
            <h3 className="modals__title">{message.title}</h3>
            <button onClick={onClose} type="button" className="modals__close">
              <img src="/account/images/dest/icons/close.svg" alt="Close" />
            </button>
          </div>

          <div className="modals__body">
            <div className="row">
              <div className="col-md-12">{message.body}</div>
            </div>
          </div>

          <div className="buttons-row">
            <button type="button" onClick={onOk} className="primary-btn">
              Yes
            </button>

            <button type="button" onClick={onClose} className="second-btn">
              No
            </button>
          </div>
        </div>
      </div>
      <div className="mask show" />
    </>
  )
}
